/**
 * [Deposit Limit Config] - IMS deposit limit config
 */
define(function(require, exports, module) {
    'use strict';

    var config = require('config');
    var server = require('server');
    var _ = require('underscore');
    var $ = require('j');
    var Class = require('Class');

    var DepositLimits = Class.create({

        UNLIMITED_AMOUNT: '9223372036854775807',
        lastFetchedLimits: null,
        noLimitsAllowed: null, // is Unlimited allowed

        /**
         * fetchDepositLimits
         * @param  {String} currency define deposit limit currency or config.get('defaultCurrency')
         * @return {Deferred} in done callback return limits object
         */

        fetchDepositLimits: function(currency) {
            var state = $.Deferred();

            server.send({
                    ID: 35604,
                    description: 'Get Deposit Limits',
                    casinoName: config.get('casinoName'),
                    responses: [35605, 35606]
                })
                .done(function(resp) {
                    state.resolve(this.success(resp, currency));
                }.bind(this))
                .fail(function() {
                    state.reject(this.fail());
                }.bind(this));

            return state;
        },

        success: function(resp, currency) {
            var data = resp.data;

            this.noLimitsAllowed = Boolean(data.noLimitsAllowed);

            return this.parseLimits(resp.data, currency);
        },

        parseLimits: function(data, currency) {
            //if type is 'Disabled' IMS all the same sends settings for predefined type
            var isDisabledType = data.predefinedType === 'disabled';
            var allLimits, currentLimit;
            if (isDisabledType) {
                allLimits = {};
                currentLimit = this.addDefaultPredefinedLimits();
            } else {
                allLimits = this.parsePredefinedLimits(data);
                this.lastFetchedLimits = allLimits;
                currentLimit = this.getLimitByCurrency(currency);
            }

            return {
                limit: currentLimit,
                limits: allLimits,
                config: this.getLimitsConfig(data)
            };
        },

        getLimitsConfig: function(data) {
            if (!data) {
                return {};
            }
            var predefinedType = data.predefinedType;
            var predefinedModeMap = {
                'disabled': '',
                'enabled': '',
                'forced': 'list',
            };
            // if disabled & 'Unlimited' is forbidden -> render only input mode
            if (predefinedType === 'disabled' && !this.noLimitsAllowed) {
                predefinedModeMap[predefinedType] = 'text';
            }

            return {
                availableTimePeriods: data.availableTimePeriods,
                isDepositListEnabled: Boolean(data.isEnabled),
                predefinedType: predefinedType,
                noLimitsAllowed: this.noLimitsAllowed,
                playerMustSetLimits: Boolean(data.playerMustSetLimits),
                allPeriodsRequired: Boolean(data.allPeriodsRequired),
                depositLimitsMode: predefinedModeMap[predefinedType],
                UNLIMITED_AMOUNT: this.UNLIMITED_AMOUNT
            };
        },

        parsePredefinedLimits: function(data) {
            if (!data) {
                return null;
            }
            var predefinedLimits = data.predefinedLimits;

            this.noLimitsAllowed && predefinedLimits.forEach(function(limit) {
                limit.allowedLimits.push(this.UNLIMITED_AMOUNT);
            }.bind(this));

            return _.indexBy(predefinedLimits, 'currency');
        },

        getLimitByCurrency: function(currency) {
            currency = currency || config.get('defaultCurrency');

            var limit = this.lastFetchedLimits[currency];

            if (limit) {
                limit.dailyDefaultLimit = Number(limit.dailyDefaultLimit);
                limit.weeklyDefaultLimit = Number(limit.weeklyDefaultLimit);
                limit.monthlyDefaultLimit = Number(limit.monthlyDefaultLimit);
            }

            return limit;
        },

        addDefaultPredefinedLimits: function() {
            return {
                allowedLimits: this.noLimitsAllowed ? [this.UNLIMITED_AMOUNT] : [],
                dailyDefaultLimit: 0,
                weeklyDefaultLimit: 0,
                monthlyDefaultLimit: 0
            };
        },

        fail: function() {
            return null;
        }
    });

    module.exports = DepositLimits;
});
